/**
 * Модель для работы с местами
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import { ICoordXY, IId, IOffice } from './types';
import MapsService, { IUpdateOfficeBody } from '../services/MapsService';

interface IState {
  list: IOffice[];
  item: IOffice | null;
  coordinates: ICoordXY | null;
}

const initialState: IState = {
  list: [],
  item: null,
  coordinates: null
};

export const infrastructureOffices = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setOffice(state: IState, payload: IOffice): IState {
      return { ...state, item: payload };
    },
    setOffices(state: IState, payload: IOffice[]): IState {
      return { ...state, list: payload };
    },
    setCoordinates(state: IState, payload: any): IState {
      return { ...state, coordinates: payload as ICoordXY };
    },
    reset(state: IState): IState {
      return { ...state, list: initialState.list };
    },
    resetSetOffice(state: IState): IState {
      return { ...state, coordinates: initialState.coordinates, item: initialState.item };
    }
  },
  effects: (dispatch: any) => ({
      async getOffices() {
        const {
          data: { data }
        } = await MapsService.getOffices();

        // ХАК
        // const offices = data.filter((item: any) => item.id !== 1);

        this.setOffices(data);
      },

      async getOffice(id: IId) {
        const { data } = await MapsService.getOffice(id);

        this.setOffice(data);
      },

      async updateOrCreate(body: IUpdateOfficeBody) {
        try {
          await MapsService.updateOrCreateOffice(body);
          await dispatch.infrastructureOffices.getOffices();
        } catch (error) {
          return error;
        }
      },

      async remove(id: IId) {
        try {
          await MapsService.deleteOffice(id);
          await dispatch.infrastructureOffices.getOffices();
        } catch (error) {
          return error;
        }
      },

      focus(center: ICoordXY) {
        const payload = { zoom: 15, center };

        dispatch.infrastructureMap.setFocus(payload);
      }
    })
});
